import { OrgDashboard } from '../components/Dashboard/OrgDashboard';

export function Dashboard() {
  return <OrgDashboard />;
}
